
import React, { useState, useEffect } from 'react';
import { Progress } from '@/components/ui/progress';

export function ReadingProgress() {
  const [readingProgress, setReadingProgress] = useState(0);

  useEffect(() => {
    const scrollHeight = document.documentElement.scrollHeight;
    const clientHeight = document.documentElement.clientHeight;
    const scrollable = scrollHeight - clientHeight;
    
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop;
      if (scrollable > 0) {
        setReadingProgress(Number((scrollTop / scrollable).toFixed(2)) * 100);
      }
    };
    
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <Progress 
      value={readingProgress} 
      className="fixed top-0 left-0 right-0 z-50 h-1 rounded-none bg-transparent" 
    />
  );
}
